import { ChevronIcon } from "@/Icons/v2/Chevron";
import { CalendarIcon } from "@/Icons/v2/DatePickerIcons/Calendar";
import { useTrans } from "@/translations";

import { useMemo } from "react";
import type { DateRange } from "react-day-picker";

import { PopoverButton } from "@headlessui/react";

import { ViewWithLoader } from "../../ViewWithLoader";
import type { PresetKey } from "../constants";
import { formatRangeLabel } from "../utils";

type Props = {
  preset: PresetKey;
  range: DateRange;
  open: boolean;
  isInitialising?: boolean;
};

export const DatePickerButton: React.FC<Props> = ({
  preset,
  range,
  open,
  isInitialising,
}) => {
  const { t } = useTrans();
  const label = useMemo(() => formatRangeLabel(preset, range), [preset, range]);

  return (
    <PopoverButton
      title="Time period"
      disabled={isInitialising}
      className="border-grey3 flex cursor-pointer flex-row items-center gap-2 rounded-lg border bg-white px-[13px] py-[9px] text-black disabled:cursor-default max-[1200px]:gap-0 max-[1200px]:px-[8.8px]"
    >
      <ViewWithLoader
        isLoading={!!isInitialising}
        loaderClassName="h-[18px] min-w-[120px] max-[1200px]:min-w-0"
      >
        <CalendarIcon />
        <span className="font-dm-sans text-[13px] font-medium max-[1200px]:hidden">
          {t(label)}
        </span>
        <ChevronIcon open={open} className="max-[1200px]:hidden" />
      </ViewWithLoader>
    </PopoverButton>
  );
};
